import {
    setMakeAction,
    setModelAction,
    setYearAction,
    setSeriesChassisAction,
    setEngineAction,
    setDetailsAction,
    setTyresAction,
    setPostcodeAction,
    setVehicleNotProvidedCommentAction
} from '../../_flux/actions/vehicle_configurator_actions';
import { Filters } from '../../_flux/constants/filter/filters';
import { resetFiltersAfterFilter } from './reset_filters_after_change';
import { checkNextEmptyValueAvailable } from './check_next_empty_value_available';

export function onConfiguratorValueChangeFactory() {
    return (newValue, filterToUpdate, props) => {
        resetFiltersAfterFilter(filterToUpdate);
        switch (filterToUpdate) {
            case Filters.VEHICLE_MAKE:
                setMakeAction(newValue);
                break;
            case Filters.VEHICLE_MODEL:
                setModelAction(newValue);
                break;
            case Filters.VEHICLE_YEAR:
                setYearAction(newValue);
                break;
            case Filters.VEHICLE_ENGINE:
                setEngineAction(newValue);
                break;
            case Filters.VEHICLE_SERIES_CHASSIS:
                setSeriesChassisAction(newValue);
                break;
            case Filters.VEHICLE_DETAILS:
                let updatedValue = newValue;
                if (props) {
                    const selectedOption = props.options.filter(o => o[0] === newValue);
                    updatedValue = { value: newValue, label: selectedOption.length ? selectedOption[0][1] : newValue };
                }
                setDetailsAction(updatedValue);
                break;
            case Filters.VEHICLE_TYRES:
                setTyresAction(newValue);
                break;
            case Filters.POSTCODE:
                setPostcodeAction(newValue);
                break;
            case Filters.VEHICLE_NOT_PROVIDED_COMMENT:
                setVehicleNotProvidedCommentAction(newValue);
                break;
        }

        checkNextEmptyValueAvailable(filterToUpdate);
    }
}
